import React from 'react';
import PropTypes from 'prop-types';

const VehicleSelection = ({ eligibleVins, onCheckBox }) => {
  if (eligibleVins) {
    return eligibleVins.map((eligibleVin) => {
      const { makeDescription, modelDescription, vin, year } = eligibleVin;
      const displayText = `${year} ${makeDescription} ${modelDescription} (${vin})`;
      return (
        <label className='checkbox-label pointer-hover' key={vin} style={{ fontWeight: 'bold' }}>
          <input
            id={vin}
            className='pointer-hover'
            type={'checkbox'}
            onChange={() => {
              onCheckBox(eligibleVin);
            }}
            checked={eligibleVin.isSelected}
            value={displayText}
          />
          <span>{displayText}</span>
        </label>
      );
    });
  } else {
    return null;
  }
};

VehicleSelection.propTypes = {
  eligibleVins: PropTypes.array,
  onCheckBox: PropTypes.func,
};

export default VehicleSelection;
